export default "__VITE_ASSET__ff4e7713__"